import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { isLakehouseContext } from '../../utils/restaurantContext';

const Footer = () => {
    const { user } = useContext(AuthContext);
    const isRestaurantTwoUser = isLakehouseContext(user);
    const footerBrand = isRestaurantTwoUser ? 'Casa Gatchalian Lakehouse' : 'Casa Gatchalian';

    return (
        <footer className="bg-gray-800 text-white py-4">
            <div className="container mx-auto text-center">
                <p>&copy; {new Date().getFullYear()} {footerBrand}. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;